export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-eject-bb13eb6a6ab65107ee0e1ff7b4ac3221.svg";